<eau-loader-holder [showLoader]="showLoader$ | async">
    <eau-page-header
        [procurementName]="procurementName$ | async"
        [procurementReferenceNumber]="procurementReferenceNumber$ | async"
        [procurementOrganizationName]="procurementOrganizationName$ | async">
    </eau-page-header>
</eau-loader-holder>